import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import { ReactComponent as VehiclePlaceholderImage } from 'src/Resources/Images/VehicleIntegration/carUnderCloth.svg'

const useStyles = makeStyles()(theme => ({
  vehicleImage: {
    width: '70%',
    aspectRatio: '16 / 9',
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
  },
  placeholderWrapper: {
    width: '70%',
    aspectRatio: '16 / 9',
    overflow: 'hidden',
  },
  placeholderImage: {
    width: '100%',
    height: '100%',
  },
}))

interface Props {
  imageUrl?: string | null
  showImage?: boolean
}

/**
 * component to shows vehicle image or vehicle place holder image
 */
const VehicleImage: React.FC<Props> = ({ imageUrl, showImage = true }) => {
  const { classes } = useStyles()

  if (showImage && imageUrl) {
    return <Box component="img" src={imageUrl} alt="vehicle-image" className={classes.vehicleImage} />
  }

  return (
    <Box className={classes.placeholderWrapper}>
      <VehiclePlaceholderImage className={classes.placeholderImage} width="100%" height="100%" />
    </Box>
  )
}

export default VehicleImage
